<script lang="ts">
import { ref } from 'vue'

export default {
  name: 'renderless-variety-pack-nutrition',
  props: {
    selected: {
      type: Number,
      required: true
    }
  },
  setup(props, { slots }) {
    const selected = ref<number>(props.selected)
    const select = (id: number) => selected.value = id
    return () => slots.default({
      selected: selected.value,
      select
    })
  }
}
</script>
